import { DriverFormValues, GpsDeviceIdOption } from '../types'

export function parseDriverFromFormValues(
  formValues: DriverFormValues,
  creating: boolean,
): uui.domain.client.rm.Driver {
  return {
    id: formValues.id,
    name: formValues.name,
    password: creating ? formValues['new-password'] : '',
    deployment: {
      email: formValues.email,
      gpsDeviceId: formValues.trackDriver
        ? getGspDeviceIdOptionValue(formValues.gpsDeviceId)
        : null,
    },
    mobileFutureDaysVisibility: parseInt(
      formValues.mobileFutureDaysVisibility,
    ) as uui.domain.client.rm.MobileFutureDaysVisibility,
    summarizeFutureMobileRoute: formValues.summarizeFutureMobileRoute,
    barcodeAttachmentAllowed: formValues.barcodeAttachmentAllowed,
  }
}

function getGspDeviceIdOptionValue(gpsDeviceIdOption: GpsDeviceIdOption | null) {
  if (!gpsDeviceIdOption) return null
  return gpsDeviceIdOption.preset === 'divider' ? null : gpsDeviceIdOption.value
}
